import { useLayoutEffect, useRef } from 'react';
import { useDispatch, type AnyAction } from '@splunk/dashboard-state';

export const useTelemetryDispatch = ({
    makeAction,
    shouldDispatch,
}: {
    makeAction: () => AnyAction;
    shouldDispatch: boolean;
}) => {
    const dispatch = useDispatch();

    const time = useRef<number | null>(null);
    const hasDispatched = useRef(false);

    if (shouldDispatch) {
        // Track the time the action SHOULD have dispatched. It'll actually be
        // dispatched in an effect to prevent setting state in the render phase
        time.current ??= performance.now();
    }

    useLayoutEffect(() => {
        if (!shouldDispatch || time.current === null || hasDispatched.current) {
            return;
        }

        hasDispatched.current = true;

        const action = makeAction();
        const patchedMetadata = { ...action.meta, time: time.current };
        dispatch(Object.assign(action, { meta: patchedMetadata }));
    }, [dispatch, makeAction, shouldDispatch]);
};
